"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryMethodEnum = void 0;
var DeliveryMethodEnum;
(function (DeliveryMethodEnum) {
    DeliveryMethodEnum["pickup"] = "pickup";
    DeliveryMethodEnum["delivery"] = "delivery";
    DeliveryMethodEnum["on_the_spot"] = "on_the_spot";
})(DeliveryMethodEnum = exports.DeliveryMethodEnum || (exports.DeliveryMethodEnum = {}));
